export default __webpack_public_path__ + "static/media/legal.ce30109a.svg";